var _g, _path, _path2, _path3, _g2, _g3, _g4, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteConfirmationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 64,
    viewBox: "0 0 63 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.58704,
    filter: "url(#filter0_f_222_14252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.1507 31.7046C61.1517 35.7095 60.3772 39.6755 58.8714 43.3759C57.3655 47.0762 55.1579 50.4386 52.3745 53.2709C49.5912 56.1032 46.2866 58.3499 42.6496 59.8828C39.0126 61.4156 35.1144 62.2046 31.1777 62.2046C27.2409 62.2046 23.3427 61.4156 19.7057 59.8828C16.0687 58.3499 12.7642 56.1032 9.98083 53.2709C7.19747 50.4386 4.98983 47.0762 3.48398 43.3759C1.97814 39.6755 1.2036 35.7095 1.20459 31.7046C1.2036 27.6996 1.97814 23.7337 3.48398 20.0333C4.98983 16.3329 7.19747 12.9706 9.98083 10.1383C12.7642 7.30601 16.0687 5.05928 19.7057 3.52641C23.3427 1.99355 27.2409 1.20459 31.1777 1.20459C35.1144 1.20459 39.0126 1.99355 42.6496 3.52641C46.2866 5.05928 49.5912 7.30601 52.3745 10.1383C55.1579 12.9706 57.3655 16.3329 58.8714 20.0333C60.3772 23.7337 61.1517 27.6996 61.1507 31.7046Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.7771 31.0643C59.7781 34.9329 59.017 38.7638 57.5372 42.3381C56.0575 45.9125 53.8881 49.1603 51.1529 51.8962C48.4178 54.632 45.1705 56.8022 41.5965 58.2829C38.0225 59.7635 34.1918 60.5256 30.3233 60.5256C26.4547 60.5256 22.624 59.7635 19.05 58.2829C15.476 56.8022 12.2287 54.632 9.49359 51.8962C6.75845 49.1603 4.58905 45.9125 3.10929 42.3381C1.62953 38.7638 0.868409 34.9329 0.869386 31.0643C0.868409 27.1958 1.62953 23.3649 3.10929 19.7905C4.58905 16.2162 6.75845 12.9683 9.49359 10.2325C12.2287 7.49666 15.476 5.32644 19.05 3.84578C22.624 2.36512 26.4547 1.60303 30.3233 1.60303C34.1918 1.60303 38.0225 2.36512 41.5965 3.84578C45.1705 5.32644 48.4178 7.49666 51.1529 10.2325C53.8881 12.9683 56.0575 16.2162 57.5372 19.7905C59.017 23.3649 59.7781 27.1958 59.7771 31.0643Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1811 31.065C57.182 34.5925 56.4879 38.0857 55.1386 41.345C53.7893 44.6043 51.8111 47.5658 49.3171 50.0605C46.8231 52.5552 43.862 54.5341 40.6031 55.8842C37.3441 57.2344 33.8511 57.9293 30.3236 57.9293C26.796 57.9293 23.303 57.2344 20.0441 55.8842C16.7851 54.5341 13.8241 52.5552 11.33 50.0605C8.83601 47.5658 6.85784 44.6043 5.50852 41.345C4.15921 38.0857 3.46517 34.5925 3.46607 31.065C3.46517 27.5374 4.15921 24.0443 5.50852 20.785C6.85784 17.5257 8.83601 14.5641 11.33 12.0695C13.8241 9.5748 16.7851 7.59588 20.0441 6.24574C23.303 4.8956 26.796 4.20068 30.3236 4.20068C33.8511 4.20068 37.3441 4.8956 40.6031 6.24574C43.862 7.59588 46.8231 9.5748 49.3171 12.0695C51.8111 14.5641 53.7893 17.5257 55.1386 20.785C56.4879 24.0443 57.182 27.5374 57.1811 31.065Z",
    fill: "#B3B3B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5146 30.9219C56.5154 34.3619 55.8386 37.7684 54.5227 40.9468C53.2068 44.1252 51.2777 47.0132 48.8455 49.446C46.4134 51.8787 43.5258 53.8085 40.3477 55.1252C37.1696 56.4418 33.7633 57.1194 30.3232 57.1194C26.8832 57.1194 23.4769 56.4418 20.2988 55.1252C17.1207 53.8085 14.2331 51.8787 11.801 49.446C9.36877 47.0132 7.43966 44.1252 6.12378 40.9468C4.8079 37.7684 4.13103 34.3619 4.13184 30.9219C4.13103 27.4819 4.8079 24.0754 6.12378 20.897C7.43966 17.7186 9.36877 14.8306 11.801 12.3978C14.2331 9.96507 17.1207 8.03528 20.2988 6.71865C23.4769 5.40203 26.8832 4.72437 30.3232 4.72437C33.7633 4.72437 37.1696 5.40203 40.3477 6.71865C43.5258 8.03528 46.4134 9.96507 48.8455 12.3978C51.2777 14.8306 53.2068 17.7186 54.5227 20.897C55.8386 24.0754 56.5154 27.4819 56.5146 30.9219Z",
    fill: "#D40000"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7362
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0478 5.69397C31.38 5.39422 34.7387 5.75384 37.9319 6.7523C41.1251 7.75076 44.0904 9.36849 46.6583 11.5131C49.2262 13.6577 51.3465 16.2872 52.8981 19.2514C54.4497 22.2155 55.4021 25.4563 55.701 28.7886C55.9999 32.1209 55.6394 35.4795 54.6402 38.6725C53.6409 41.8655 52.0224 44.8303 49.8772 47.3977C47.7319 49.9651 45.1019 52.0847 42.1373 53.6355C39.1728 55.1863 35.9317 56.138 32.5994 56.436C29.2671 56.7358 25.9085 56.3762 22.7153 55.3777C19.522 54.3792 16.5568 52.7615 13.9888 50.6169C11.4209 48.4723 9.3006 45.8428 7.74904 42.8786C6.19747 39.9145 5.24504 36.6737 4.94613 33.3414C4.64722 30.0091 5.00769 26.6505 6.00696 23.4575C7.00622 20.2646 8.6247 17.2997 10.77 14.7323C12.9152 12.1649 15.5452 10.0453 18.5098 8.49447C21.4744 6.94366 24.7154 5.99204 28.0478 5.69397Z",
    fill: "url(#paint0_radial_222_14252)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.80921
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.1295 21.4055C51.1295 30.2557 41.8084 37.4385 30.3234 37.4385C18.8385 37.4385 9.51733 30.2557 9.51733 21.4055C9.51733 12.5553 18.8385 5.37256 30.3234 5.37256C41.8084 5.37256 51.1295 12.5553 51.1295 21.4055Z",
    fill: "url(#paint1_radial_222_14252)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.66397,
    filter: "url(#filter1_f_222_14252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6562 10.2816L51.8417 40.1159C52.9118 41.816 53.3087 42.6253 53.2655 43.3813C53.2655 43.3813 53.5279 45.3072 51.9248 46.2394C51.1145 46.7106 49.4768 46.5762 49.4768 46.5762L12.0637 46.5195C10.7319 46.5071 8.06589 46.7779 7.36664 44.0215C7.25891 42.7461 7.71935 41.6063 8.74796 40.1159L26.9335 10.2816C28.2629 8.10065 32.1981 8.04903 33.6562 10.2816Z",
    fill: "black"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1275 11.0648L49.8423 39.2454C50.8258 40.8513 51.1906 41.6157 51.151 42.3298C51.151 42.3298 51.3922 44.1489 49.9187 45.0294C49.1739 45.4745 47.6687 45.3476 47.6687 45.3476L13.2812 45.294C12.0571 45.2823 9.60673 45.5381 8.96403 42.9345C8.86502 41.7298 9.28822 40.6532 10.2336 39.2454L26.9485 11.0648C28.1703 9.0048 31.7873 8.95603 33.1275 11.0648Z",
    fill: "url(#paint2_linear_222_14252)",
    stroke: "#CCCCCC",
    strokeWidth: 0.914476
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9698 12.7788C28.3646 12.7788 27.6065 13.1801 27.6065 14.1165C27.6065 14.83 27.7403 15.8556 27.9186 17.6838C28.5429 22.7671 28.8105 27.9396 29.2118 33.6472C29.4347 33.9593 30.5495 33.9593 30.7724 33.6472C31.1737 27.9396 31.4859 22.7671 32.0656 17.6838C32.2885 15.8556 32.3777 14.83 32.3777 14.1165C32.3777 13.1801 31.6197 12.7788 30.0144 12.7788H29.9698ZM30.0144 42.9666C31.4859 42.9666 32.5561 41.941 32.5561 40.3357C32.5561 38.8643 31.4859 37.7495 30.0144 37.7495C28.5875 37.7495 27.5173 38.8643 27.5173 40.3357C27.5173 41.941 28.5875 42.9666 29.9698 42.9666H30.0144Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_222_14252",
    x: 0.0000983477,
    y: 0.0000983477,
    width: 62.355,
    height: 63.409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.602246,
    result: "effect1_foregroundBlur_222_14252"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_222_14252",
    x: 5.51376,
    y: 6.7889,
    width: 49.6053,
    height: 41.6424,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.91878,
    result: "effect1_foregroundBlur_222_14252"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_222_14252",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.03848 -35.495 73.1885 -2.14105 31.3619 56.5393)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_222_14252",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.3234 5.37254) rotate(90) scale(32.0669 46.4152)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.49804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_222_14252",
    x1: 27.7167,
    y1: 41.9109,
    x2: 27.8405,
    y2: 25.8157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteConfirmationIcon);
export default __webpack_public_path__ + "static/media/delete_confirmation_icon.060ce2a7f2c2e14eeb5b1d8d7eb95d6c.svg";
export { ForwardRef as ReactComponent };